import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ZuiShellBase } from './zui-shell-base';
import { style } from './zui-shell-help-css.js';

/**
 * @ignore
 * DO NOT USE. This component will be massively reworked in a future release. Only to be used by <zywave-shell>
 * A component to help render standardized help actions.
 *
 * @element zui-shell-help
 *
 */
export class ZuiShellHelp extends ZuiShellBase {
  static get styles() {
    return [super.styles, style];
  }

  @property({ type: String, attribute: 'help-header' })
  helpHeader: string | null = null;

  @property({ type: String })
  icon = 'zui-help';

  @property({ type: Boolean })
  open = false;

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('click', (e) => {
      if (!e.composedPath().includes(this)) {
        this._toggleOpen(false);
      }
    });
  }

  #renderMobileTemplate() {
    const icon = this.icon ?? 'zui-help';

    return html`
      <div class="help-training ${classMap({ open: !!this.open })}">
        <button class="help-training-button" @click="${() => this._toggleOpen()}">
          <zui-icon icon="${icon}"></zui-icon>
        </button>
        <div class="help-training-dropdown">
          <div class="header">${this.helpHeader ?? ''}</div>
          <slot></slot>
        </div>
      </div>
    `;
  }

  #renderDesktopTemplate() {
    return html`
      <div class="help-training ${classMap({ open: !!this.open })}">
        <zui-button type="secondary" @click="${() => this._toggleOpen()}">${this.helpHeader}</zui-button>
        <div class="help-training-dropdown">
          <div class="header">${this.helpHeader ?? ''}</div>
          <slot></slot>
        </div>
      </div>
    `;
  }

  render() {
    return this._isMobile || this._isTablet ? this.#renderMobileTemplate() : this.#renderDesktopTemplate();
  }

  _toggleOpen(force?: boolean) {
    this.open = force !== undefined ? force : !this.open;
  }
}

window.customElements.define('zui-shell-help', ZuiShellHelp);

declare global {
  interface HTMLElementTagNameMap {
    'zui-shell-help': ZuiShellHelp;
  }
}
